export default __webpack_public_path__ + "static/media/Tim.74e1d99a.jpg";